import React from "react";
import { Link } from "react-router-dom";
import { map } from "lodash";

const Breadcrumb = ({ items }) => {
  if (items.length === 0) {
    return null;
  }
  return (
    <ul class="breadcrumb">
      {map(items, (item, index) => {
        if (index === items.length - 1) {
          return <li>{item.label}</li>;
        } else {
          return (
            <li>
              <Link to={item.link}>{item.label}</Link>
            </li>
          );
        }
      })}
    </ul>
  );
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/_components/Layout/PageTitle/Breadcrumb/index.js